export const CHECKOUT_URL = 'https://saldatura.impultienda.ar/checkout/'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/sjzPRfr5ij9x98jUXqco3N/SOLDADURA-IT.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/c780703e-3e26-4516-8f5e-5c0fe6b07fa1.jpg'

export const stats = [
  { value: '+300', label: 'SOLUZIONI PRATICHE' },
  { value: '+1.200', label: 'SALDATORI' },
  { value: '6', label: 'MANUALI MAESTRI' },
  { value: '99%', label: 'LO RACCOMANDA' },
]

export const painPoints = [
  'Sprechi materiale a causa di impostazioni errate.',
  'Indovini l’amperaggio ogni volta che cambia lo spessore del materiale.',
  'I tuoi cordoni risultano diversi da una prova all’altra.',
  'Non sai se la saldatura sarà realmente abbastanza resistente.',
  'Ogni nuovo progetto inizia con dubbi e improvvisazione.',
]

export const gains = [
  'Saprai esattamente quali impostazioni controllare prima di iniziare.',
  'Otterrai cordoni più puliti, resistenti e uniformi.',
  'Ridurrai lo spreco di elettrodi e materiale.',
  'Individuerai e correggerai gli errori più rapidamente.',
  'Saldarai con la sicurezza di chi sa cosa sta facendo.',
]

export const forYou = [
  'Hai una saldatrice, ma non hai mai imparato davvero a utilizzarla correttamente.',
  'Impari da YouTube, ma ogni video sembra dirti qualcosa di diverso.',
  'Hai sempre dubbi prima di configurare la macchina.',
  'Sprechi elettrodi e materiale a causa di errori evitabili.',
  'Vuoi realizzare i tuoi progetti con maggiore sicurezza.',
  'Vuoi smettere di dipendere dagli altri per le riparazioni.',
  'Vuoi ottenere risultati più puliti, uniformi e professionali.',
]

export const manuals = [
  {
    number: '01',
    title: 'METODO ZERO ERRORI™',
    text: 'Scopri cosa controllare prima di iniziare a saldare per evitare gli errori più comuni fin dal primo giorno.',
  },
  {
    number: '02',
    title: 'CONTROLLO TOTALE DELL’ARCO™',
    text: 'Migliora il controllo della tecnica di saldatura per ottenere cordoni più puliti, uniformi e resistenti.',
  },
  {
    number: '03',
    title: 'CODICE MAESTRO DELLA CONFIGURAZIONE™',
    text: 'Impara a configurare correttamente la tua saldatrice senza dover continuare a indovinare le impostazioni.',
  },
  {
    number: '04',
    title: 'SALDATURE SENZA LIMITI™',
    text: 'Impara ad affrontare diverse posizioni di saldatura con maggiore controllo e sicurezza.',
  },
  {
    number: '05',
    title: 'LABORATORIO DIAGNOSTICO DEL SALDATORE™',
    text: 'Impara a riconoscere i difetti più comuni e a capire cosa correggere invece di ripetere lo stesso errore.',
  },
  {
    number: '06',
    title: 'FINITURA PROFESSIONALE™',
    text: 'Migliora la pulizia, la molatura e la finitura per ottenere progetti dall’aspetto più pulito e professionale.',
  },
]

export const deliverables = [
  {
    icon: '📘',
    title: 'I 6 MANUALI MAESTRI',
    text: 'Manuali digitali completi progettati per essere consultati facilmente mentre impari e saldi.',
  },
  {
    icon: '⚡',
    title: 'OLTRE 300 SOLUZIONI PRATICHE',
    text: 'Soluzioni chiare e pratiche organizzate intorno ai problemi più comuni che potresti incontrare in officina.',
  },
  {
    icon: '📊',
    title: 'TABELLE DI CONFIGURAZIONE A CONSULTAZIONE RAPIDA',
    text: 'Tabelle facili da consultare per aiutarti a prendere decisioni migliori prima di iniziare a saldare.',
  },
  {
    icon: '🔍',
    title: 'GUIDE VISIVE PER LA DIAGNOSI DEGLI ERRORI',
    text: 'Riconosci i problemi più comuni e scopri cosa controllare o modificare invece di ripetere lo stesso errore.',
  },
  {
    icon: '✅',
    title: 'CHECKLIST DI CONSULTAZIONE RAPIDA',
    text: 'Semplici checklist da utilizzare prima, durante e dopo le tue sessioni di saldatura.',
  },
  {
    icon: '📱',
    title: 'ACCESSO DA QUALSIASI DISPOSITIVO',
    text: 'Utilizza i manuali dal tuo smartphone, tablet o computer ogni volta che ne hai bisogno.',
  },
]

export const bonuses = [
  {
    tag: 'BONUS #1',
    image:
      'https://cdn.magicpatterns.com/uploads/rrdMzLT7SXq7Zi6b1bR7d7/BONUS_1_SOLDADURA-IT.png',
    title: 'CENTRO DEI COSTI DEL SALDATORE™',
    promise: 'Scopri esattamente quanto ti costa ogni lavoro di saldatura.',
    text: 'Smetti di indovinare quanto chiedere. Impara a calcolare correttamente materiali, elettrodi, elettricità, manodopera e altri costi del progetto per stabilire prezzi più consapevoli.',
    value: '$47',
  },
  {
    tag: 'BONUS #2',
    image:
      'https://cdn.magicpatterns.com/uploads/7syrDSrmjVoTkvvoNyxYcd/BONUS_2_SOLDADURA-IT.png',
    title: 'FINITURA PREMIUM™',
    promise: 'Fai sembrare ogni tuo progetto realizzato in un’officina professionale.',
    text: 'Scopri i dettagli di finitura che fanno la differenza: pulizia, molatura, preparazione della superficie, verniciatura e presentazione finale.',
    value: '$37',
  },
  {
    tag: 'BONUS #3',
    image:
      'https://cdn.magicpatterns.com/uploads/uTfcMLqUT4yvjtBZk3i8dC/BONUS_3_SOLDADURA-IT.png',
    title: 'BIBLIOTECA DEI CORDONI PERFETTI™',
    promise: 'Confronta, identifica e correggi i difetti più comuni di saldatura.',
    text: 'Una raccolta visiva che ti aiuta a confrontare i tuoi cordoni, riconoscere i problemi e capire cosa controllare per migliorare il risultato.',
    value: '$67',
  },
  {
    tag: 'BONUS #4',
    image:
      'https://cdn.magicpatterns.com/uploads/k2KV8QtKZCsBfRRSHc19o5/BONUS_4_ITALIANO-IT.png',
    title: 'KIT MAESTRO PER TROVARE CLIENTI™',
    promise: 'Trasforma le tue competenze di saldatura in nuove opportunità.',
    text: 'Modelli di messaggi, strategie e strumenti pratici per presentare i tuoi servizi, rispondere ai potenziali clienti e ottenere nuovi lavori.',
    value: '$57',
  },
  {
    tag: 'BONUS #5',
    image:
      'https://cdn.magicpatterns.com/uploads/96mSirUc3iH7ffCQ91qLdD/BONUS_5_SOLDADURA-IT.png',
    title: 'AUDIT PROFESSIONALE DELL’OFFICINA™',
    promise: 'Crea un ambiente che trasmetta professionalità e fiducia.',
    text: 'Scopri quali dettagli della tua officina e della presentazione del tuo servizio possono influenzare la percezione dei clienti e come migliorarli.',
    value: '$37',
  },
]

export const testimonials = [
  {
    name: 'Carlos M.',
    role: 'Saldatore',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/81dab89d-9e82-453c-8dfc-4255c956588b.jpg',
    quote:
      'Avevo la saldatrice da due anni e continuavo a indovinare l’amperaggio. Con le tabelle di configurazione riesco a partire da un riferimento chiaro e spreco molti meno elettrodi.',
  },
  {
    name: 'Nahuel R.',
    role: 'Appassionato di saldatura',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/5207d56e-84fb-4aea-88e1-cd5fbd7ed65f.jpg',
    quote:
      'Imparavo tutto da YouTube, ma ogni video sembrava dire qualcosa di diverso. Ora ho tutto organizzato in un unico posto e posso consultare rapidamente ciò di cui ho bisogno.',
  },
  {
    name: 'Diego F.',
    role: 'Saldatore indipendente',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/e47a1bdd-7450-419c-87c9-fe63ab41e2b4.jpg',
    quote:
      'La sezione per la diagnosi degli errori è davvero utile. Ora posso osservare il cordone, capire cosa potrebbe essere andato storto e sapere cosa controllare.',
  },
]

export const faqs = [
  {
    q: 'Come riceverò il Sistema Maestro?',
    a: 'Subito dopo il pagamento riceverai un’e-mail con l’accesso ai 6 Manuali Maestri e ai 5 Bonus Esclusivi in formato digitale.',
  },
  {
    q: 'È adatto anche a chi non ha mai saldato?',
    a: 'Sì. Il sistema è progettato per fornire ai principianti un riferimento chiaro e aiutarli a evitare molti degli errori comuni che derivano dall’apprendimento attraverso tentativi ed errori.',
  },
  {
    q: 'Funziona anche se ho già esperienza?',
    a: 'Sì. Può essere utilizzato come guida di consultazione rapida quando hai bisogno di controllare una configurazione, diagnosticare un problema o ripassare una tecnica.',
  },
  {
    q: 'Ho bisogno di internet?',
    a: 'È necessaria una connessione Internet per ricevere e scaricare i file digitali. Dopo averli scaricati, puoi consultare i manuali offline sul tuo dispositivo.',
  },
  {
    q: 'È un pagamento unico?',
    a: 'Sì. Paghi una sola volta e ricevi accesso a vita. Non ci sono abbonamenti mensili né pagamenti ricorrenti.',
  },
  {
    q: 'Cosa succede se non mi piace?',
    a: 'Se decidi che il sistema non fa per te, sei protetto dalla Garanzia di Soddisfazione di 7 Giorni. Contattaci entro 7 giorni per richiedere il rimborso.',
  },
]

export const purchaseAlerts = [
  { name: 'Javier G.', place: 'Buenos Aires, Argentina' },
  { name: 'Miguel Á.', place: 'Città del Messico, Messico' },
  { name: 'Andrés P.', place: 'Bogotá, Colombia' },
  { name: 'Luis F.', place: 'Lima, Perù' },
  { name: 'Rodrigo S.', place: 'Santiago, Cile' },
  { name: 'Carlos R.', place: 'Madrid, Spagna' },
  { name: 'Diego M.', place: 'Montevideo, Uruguay' },
  { name: 'Fernando L.', place: 'Guayaquil, Ecuador' },
  { name: 'Pablo N.', place: 'Asunción, Paraguay' },
  { name: 'Héctor V.', place: 'Guadalajara, Messico' },
  { name: 'Marcelo T.', place: 'Rosario, Argentina' },
  { name: 'Julián C.', place: 'Medellín, Colombia' },
]
